import { postPhoneValidate } from "../../../../app/api/phoneUpdation";
import { BaseAction } from "../../../../core/actions/BaseAction";
import { getTranslatedMessage } from "../../../../Lib/Utils/i18n";
import { updateRecoilState } from "../../../../Orchestrator/Recoils/Events/Recoil";
import { IDefaultActionResult } from "../../../../Orchestrator/Types/Interface/ActionParams/DefaultActionResult";
import { IPhoneNumberOtpVerifyActionParams } from "../../../../Orchestrator/Types/Interface/ActionParams/PhoneNumberVerifyActionParams";
import { invalidateUserCaches } from "../invalidateUserCaches";


class PhoneNumberOtpVerifyAction extends BaseAction<IDefaultActionResult, IPhoneNumberOtpVerifyActionParams> {
    override async run(): Promise<IDefaultActionResult> {
        let actionResult: IDefaultActionResult = {
            data: [],
            message: "",
            status: "fail"
        }
        try {
            const { customerId, code } = this.params!;            
            if (customerId && code && code != "") {
                const payload = {
                    code: code
                }
                const response: any = await postPhoneValidate(customerId, payload);
                if (response.status === 'ok' && response.answer) {
                    updateRecoilState("userDataAtom", response.answer);
                    invalidateUserCaches();
                    updateRecoilState("isOtpVerifiedAtom", true);
                    updateRecoilState("otpErrorAtom", "");
                    actionResult.status = "success"
                    actionResult.data = response.answer
                } else {
                    updateRecoilState("otpErrorAtom", getTranslatedMessage("wrongOtpPleaseTryAgain"));
                }
            }
        } catch (error) {
            console.error("Error in PhoneNumberOtpVerifyAction:", error);
            actionResult.message = "Something went wrong"
            updateRecoilState("otpErrorAtom", getTranslatedMessage("wrongOtpPleaseTryAgain"));
        } finally {
            return actionResult
        }
    }
}

export const phoneNumberOtpVerifyAction = new PhoneNumberOtpVerifyAction()


